'use client'
import React, {useContext } from 'react';
import { MenuList } from '@/components/menuList';
import { Text } from '@chakra-ui/layout';
import { Icon, IconButton, Menu, MenuButton, MenuItem } from '@chakra-ui/react';
import {MdAdd, MdMoreHoriz, MdOutlineDelete } from 'react-icons/md';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { PersonaContext } from '../../lib/personaContext';
import { PersonaPageContext } from '../lib/personaPageContext';
import DeletePersonaModal from '../../components/deletePersonaModal';
import useTranslation from '../../../lib/i18n/useTranslation';
export default function PersonaAsideEditMenu() {
  const { t } = useTranslation();
  const {
    persona,
    rights,
  } = useContext(PersonaContext);
  const {
    setEditingQuote,
    setEditingAttributes,
    setEditingBio,
    setEditingUsefulLinks,
    sharedExperienceList,
    setAddingSharedExperience,
  } = useContext(PersonaPageContext);
  const modalDelete = useDisclosure();
  return (
    <>
      {(persona && rights.can_update) && (
        <>
          <Menu>
            {({ isOpen }) => (
              <>
                <MenuButton
                  isActive={isOpen}
                  as={IconButton}
                  icon={<MdMoreHoriz />}
                  variant='blueOutline'
                />
                <MenuList>
                  {!persona.bio &&
                    <MenuItem onClick={() => {
                      setEditingBio(true);
                    }}>
                        <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('persona.addBio')}
                    </MenuItem>
                  }
                  {!persona.quote &&
                    <MenuItem onClick={() => {
                      setEditingQuote(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('persona.addQuote')}
                    </MenuItem>
                  }
                  {!(
                    persona.job
                    || persona.location
                    || persona.age
                    || persona.education
                    || persona.fammily_status
                    || persona.interests
                  ) &&
                    <MenuItem onClick={() => {
                      setEditingAttributes(true)
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('persona.addAttributes')}
                    </MenuItem>
                  }
                  {(!sharedExperienceList || sharedExperienceList.length === 0) && (
                    <MenuItem onClick={() => {
                      setAddingSharedExperience(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('persona.addSharedExperience')}
                    </MenuItem>
                  )}
                  {(!persona.useful_links || persona.useful_links.length === 0) && (
                    <MenuItem onClick={() => {
                      setEditingUsefulLinks(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('persona.addUsefulLinks')}
                    </MenuItem>
                  )}
                  {rights.can_delete && (
                    <MenuItem onClick={() => {
                      modalDelete.onOpen();
                    }}>
                        <Icon
                        as={MdOutlineDelete}
                        color='text.medium.red'
                        boxSize={'14px'}
                        mr={2}
                      />
                      <Text color='text.medium.red' >{t('common.delete')}</Text>
                      <DeletePersonaModal disclosure={modalDelete} />
                    </MenuItem>
                  )}
                </MenuList>
              </>
            )}
          </Menu>
        </>
      )}
    </>
  )
}
